import React from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import CommonButton, { BUTTON_STYLES } from '../common-button/CommonButton';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import { openContactModal } from '../../redux/global/globalReducer';
import { history } from '../../store';

import scss from './ErrorFallback.module.scss';

const HOME_PATH = '/projects';

function ErrorFallback({ error, reset, variant = 'page' }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isRoot = variant === 'root';
  const isDev = import.meta.env.DEV;

  const handleTryAgain = () => {
    reset();
  };

  const handleGoHome = () => {
    if (pathname !== HOME_PATH) {
      history.push(HOME_PATH);
      if (isRoot) {
        reset();
      }
      return;
    }

    reset();
  };

  const handleOpenContactModal = () => {
    dispatch(openContactModal());
  };

  return (
    <div className={clsx(scss.root, isRoot && scss.rootFixed)} role='alert'>
      <div className={scss.content}>
        <div className={scss.mark}>
          <span className={scss.halo} aria-hidden />
          <HexRing className={scss.ring} />
          <Icon icon={ICONS.Logo} className={scss.logo} disableCommonStyles disableCommonColors />
        </div>

        <h1 className={scss.title}>{t('thisPageIsntWorkingRightNow')}</h1>
        <p className={scss.description}>{t('youCanTryAgainOrGoToTheHomePage')}</p>

        {isDev && error?.message ? <code className={scss.devMessage}>{error.message}</code> : null}

        <div className={scss.actions}>
          <CommonButton
            styleColor={BUTTON_STYLES.PRIMARY}
            onClick={handleTryAgain}
            isStrokeIcon
            LeftIcon={<Icon icon={ICONS.Reload} disableCommonStyles disableCommonColors />}>
            {t('tryAgain')}
          </CommonButton>
          <CommonButton
            styleColor={BUTTON_STYLES.SECONDARY}
            onClick={handleGoHome}
            LeftIcon={<Icon icon={ICONS.Return} disableCommonStyles disableCommonColors />}>
            {t('goToHome')}
          </CommonButton>
        </div>

        <button type='button' className={scss.contact} onClick={handleOpenContactModal}>
          {t('contactSupport')}
        </button>
      </div>
    </div>
  );
}

export default ErrorFallback;

function HexRing({ className }) {
  return (
    <svg className={className} viewBox='0 0 100 100' aria-hidden>
      <polygon points='50,4 93,27 93,73 50,96 7,73 7,27' fill='none' stroke='currentColor' strokeWidth='1.25' />
    </svg>
  );
}
